<template>
  <div class="sourcing-page pc-container">
    <div class="breadcrumb"><router-link to="/pc">首页</router-link><span> / 在线找料</span></div>
    <section class="sourcing-card">
      <h1>在线找料</h1>
      <div v-if="receipt" class="receipt" role="status">
        <h2>找料需求已提交</h2><p>找料编号：{{ receipt.requestNo }}</p><p>处理状态：{{ receipt.status }}</p>
        <router-link v-if="hasMember" to="/pc/member/sourcing">查看我的找料</router-link>
        <button class="primary" @click="resetForm">继续找料</button>
      </div>
      <form v-else @submit.prevent="submit">
        <label><span><em>*</em> 产品型号</span><input v-model.trim="form.model" maxlength="200" required placeholder="请输入产品型号" :disabled="saving"></label>
        <label><span>数量</span><input v-model="form.quantity" type="number" min="1" max="2147483647" step="1" placeholder="请输入数量" :disabled="saving"></label>
        <label v-if="!hasMemberPhone"><span><em>*</em> 联系电话</span><input v-model.trim="form.contactPhone" type="tel" maxlength="30" required placeholder="请输入联系电话" :disabled="saving"></label>
        <label v-if="!hasMember"><span>联系人</span><input v-model.trim="form.contactName" maxlength="100" placeholder="请输入联系人" :disabled="saving"></label>
        <label><span>备注</span><textarea v-model.trim="form.remark" maxlength="2000" rows="4" placeholder="请输入备注" :disabled="saving"></textarea></label>
        <p v-if="error" class="error" role="alert">{{ error }}</p>
        <button class="primary" type="submit" :disabled="saving || profileLoading">{{ saving ? '提交中...' : '提交找料请求' }}</button>
        <router-link v-if="hasMember" class="records-link" to="/pc/member/sourcing">我的找料</router-link>
      </form>
    </section>
  </div>
</template>

<script>
import { submitPcSourcing, getPcMemberProfile } from '@/api/pc'
import pcAuth from '@/utils/pcAuth'
import sourcing from '@/utils/sourcing'

export default {
  name: 'PcSourcing',
  data() {
    return { form: { model: '', quantity: '', remark: '', contactName: '', contactPhone: '' },
      saving: false, profileLoading: false, error: '', receipt: null, member: null, requestId: '', submittedPayload: '' }
  },
  computed: {
    hasMember() { return Boolean(this.member) },
    hasMemberPhone() { return Boolean(this.member && (this.member.contactPhone || this.member.registeredPhone || this.member.phone)) }
  },
  watch: { '$route.query.model'(model) { if (!this.saving) { this.form.model = String(model || '').slice(0, 200); this.receipt = null } } },
  created() {
    this.form.model = String(this.$route.query.model || '').slice(0, 200)
    if (pcAuth.getToken()) {
      this.profileLoading = true
      getPcMemberProfile().then(member => { this.member = member }).catch(() => { pcAuth.clearLogin(); this.member = null }).finally(() => { this.profileLoading = false })
    }
  },
  methods: {
    async submit() {
      if (this.saving || this.profileLoading) return
      this.error = sourcing.validateSourcing(this.form, this.hasMemberPhone)
      if (this.error) return
      const payload = { ...this.form, quantity: this.form.quantity === '' ? null : Number(this.form.quantity) }
      const snapshot = JSON.stringify(payload)
      if (!this.requestId || snapshot !== this.submittedPayload) {
        const bytes = new Uint8Array(16)
        window.crypto.getRandomValues(bytes)
        this.requestId = Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('')
        this.submittedPayload = snapshot
      }
      this.saving = true
      try { this.receipt = await submitPcSourcing({ ...payload, clientRequestId: this.requestId }) }
      catch (error) { this.error = error.message || '提交失败，请重试' }
      finally { this.saving = false }
    },
    resetForm() {
      this.form = { model: '', quantity: '', remark: '', contactName: '', contactPhone: '' }
      this.receipt = null; this.error = ''; this.requestId = ''; this.submittedPayload = ''
    }
  }
}
</script>

<style scoped>
.sourcing-page{padding:24px 0 70px;min-height:650px}.breadcrumb{color:#7a8494;margin-bottom:36px}.sourcing-card{width:590px;margin:0 auto;padding:28px;background:#fff;border:1px solid #e4e8ef;border-radius:12px;box-sizing:border-box}.sourcing-card h1{font-size:25px;color:#15243b;margin:0 0 22px}.sourcing-card label{display:block;margin-bottom:20px}.sourcing-card label span{display:block;color:#727e90;margin-bottom:8px}.sourcing-card em,.error{color:#cf3030;font-style:normal}.sourcing-card input,.sourcing-card textarea{box-sizing:border-box;width:100%;border:1px solid #d4dae3;border-radius:7px;padding:10px 12px;font:inherit;background:#fff}.sourcing-card input:focus,.sourcing-card textarea:focus{outline:1px solid #0b3b91}.sourcing-card textarea{resize:vertical}.primary{width:100%;min-height:44px;padding:10px 16px;background:#0b3b91;color:#fff;border:0;border-radius:6px;cursor:pointer;font:inherit;line-height:1.4}.primary:disabled{opacity:.6;cursor:wait}.records-link{display:block;text-align:center;margin-top:16px}.receipt p{overflow-wrap:anywhere}.receipt .primary{margin-top:20px}.receipt a{display:inline-block;margin-top:10px}
</style>
